module.exports = __webpack_public_path__ + "media/images/article/2021_07-784b3688c4ab5ac5399eda6c198869cf.png";